import Discussion from 'shared/components/discussion';
import AdminDiscussion from 'shared/components/admin_discussion';
import Page from 'shared/components/page';
import Env from 'shared/env';
import SocketAPI from 'vidio-chat';
import DiscussionLivestreaming from 'shared/components/discussion_livestreaming';
import { VidioHelpers } from 'shared/vidio_helpers';

export default class WebSocketConnection {
  constructor(options) {
    const wsOptions = {
      conversation: {
        id: Page.id()
      },
      host: {
        chat: Env.vidioChatHost(),
        secure: Env.vidioChatSecure()
      }
    };

    this.element = options.element;
    this.ws = SocketAPI.initialize(wsOptions);
    this.retryCounter = 0;
    this.discussion = new Discussion();
    this.discussionLivestreaming = new DiscussionLivestreaming();

    this.isComponentInitialized = false;
    this.messageBuffer = [];
  }

  init() {
    WebSocketConnection.createInstructionBuffer();
    return this.getToken()
      .then(token => {
        sessionStorage.setItem('token', JSON.stringify(token));
        this.initSession(token);
      })
      .then(() => {
        this.initDiscussionLivestreaming();
      });
  }

  initDiscussionLivestreaming() {
    return this.discussionLivestreaming
      .init()
      .then(data => {
        if (data.template_name == "AdminDiscussion" && !VidioHelpers.isMobile()) {
           this.discussion = new AdminDiscussion();
        }

        this.isComponentInitialized = true;
        this.renderBufferedMessage();
      });
  }

  renderBufferedMessage() {
    while (this.messageBuffer.length > 0) {
      const bufferMsg = this.messageBuffer.shift();
      this.onMessage(bufferMsg);
    }
  }

  runBufferedInstructions() {
    while (window.instructionBuffer.length > 0) {
      const instruction = window.instructionBuffer.shift();
      instruction();
    }
  }

  onOpen() {
    SocketAPI.subscribe(`utility/anti-piracy/${Page.id()}`)
    this.runBufferedInstructions();
  }

  onMessage(message) {
    if (['pin', 'get-pin-message'].includes(message.type) && !this.isComponentInitialized) {
      this.messageBuffer.push(message);
    } else if (message.type === 'utility/antipiracy') {
      window.player.toggleWatermark(message.duration);
    }

    this.discussion.renderIncomingWsMessage(message);
  }

  getToken() {
    return this.ws.token.refresh();
  }

  initSession(token) {
    if(token !== undefined && token.realtime !== undefined && token.web !== undefined) {
      const initOptions = {
        token: token.realtime,
        websocketCallback: {
          onOpenCallback: this.onOpen.bind(this),
          onMessageCallback: this.onMessage.bind(this),
          onConnectFailed: this.onConnectFailed.bind(this)
        }
      };

      const isToggleOn = this.element.dataset.useNewConnection === 'true';

      this.ws.session.init(initOptions, isToggleOn);
      SocketAPI.storeSocket(this.ws.session.wsAdapter);
    } else if (this.retryCounter < 3) {
      this.retryCounter++;
      this.init();
    }
  }

  onConnectFailed() {
    this.discussion.load();
  }

  static createInstructionBuffer() {
    window.instructionBuffer = [];
  }

  static runWhenOpen(instruction) {
    const readyState = SocketAPI.readyState();

    if (readyState === 0) {
      window.instructionBuffer.push(instruction);
    } else if (readyState === 1) {
      instruction();
    }
  }
}
